// Section G. There is no error field: a post that was Scheduled and shows up as Draft
// after its date means LinkedIn could not publish the video.
export const publishFailed = (post) => {
  if (!post?.videoId && !post?.videoUrl) return false;
  if (post.status !== "Draft" || !post.publicationDateTime) return false;
  const when = new Date(String(post.publicationDateTime).replace(" ", "T")); // Safari needs the T
  return Number.isNaN(when.getTime()) || when <= new Date();
};